<!-- Modal -->
<div class="modal fade" id="exampleModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle"
	aria-hidden="true">
	<div class="modal-dialog modal-dialog-centered modal-sm" role="document">
		<div class="modal-content">
			<div class="modal-header">
				<h5 class="modal-title" id="exampleModalLongTitle">{{ modalTitle }}</h5>
				<button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="CloseClick()">
					<span aria-hidden="true">&times;</span>
				</button>
			</div>
			<div class="modal-body">
				<app-encash [summary]="summary" *ngIf="activateEncash">
				</app-encash>
			</div>
		</div>
	</div>
</div>
<!-- <button (click) = "Test()"></button> -->
<div class="col-md-12">
	<div class="card" style="border-radius: 0.5rem">
		<div class="card-body">
			<div class="container-fluid">
				<p *ngIf="summaryLastGenerated && summaryLastGeneratedFor"><small>Summaries were last generated on <b>{{summaryLastGenerated | date: 'mediumDate'}}</b> for
						<b>{{summaryLastGeneratedFor | date: 'MMMM YYYY'}}</b></small></p>
			</div>
			<div class="row">
				<div class="col-md-12">
					<div class="container-fluid my-4">
						<div class="row mt-4">
							<h1 class="col-7">
								Showing leave summaries for the month of
								<div class="btn-group">
									<div class="dropdown">
										<h1 class="btn btn-outline-dark btn-sm dropdown-toggle" role="button"
											id="dropdownMonth" data-toggle="dropdown" aria-haspopup="true"
											aria-expanded="false">
											{{ month }}
										</h1>
										<div class="dropdown-menu" aria-labelledby="dropdownMonth">
											<button *ngFor="let item of monthDropdown" class="dropdown-item"
												type="button" (click)="UpdateMonth(item.Value, item.Text)">
												{{ item.Text }}
											</button>
										</div>
									</div>
									<div class="dropdown inline">
										<h1 class="btn btn-outline-dark btn-sm dropdown-toggle" role="button"
											id="dropdownYear" data-toggle="dropdown" aria-haspopup="true"
											aria-expanded="false">
											{{ year }}
										</h1>
										<div class="dropdown-menu" aria-labelledby="dropdownYear">
											<button *ngFor="let item2 of yearDropdown" class="dropdown-item"
												type="button" (click)="UpdateYear(item2)">
												{{ item2 }}
											</button>
										</div>
									</div>
								</div>
							</h1>
							<div class="col-5">
								<button (click)="SendMail()" class="float-right m-1 btn btn-danger"> Send Email
								</button>
								<button (click)="CloseMonth()" class="float-right m-1 btn btn-danger"> Close the Month
								</button>
							</div>
						</div>
						<button (click)="Test()"></button>
						<div class="container-fluid ">
							<table datatable dt-instance="dtInstance" [dtOptions]="dtOptions" [dtTrigger]="dtTrigger"
								class="row-border hover table-responsive" style="height: 700px; overflow-y: scroll;">
								<thead class="small sticky-row first-row text-right">
									<tr>
										<th class="wid-10-p sticky-row first-row">
											Employee Name
										</th>
										<th class="wid-6pt4-p sticky-row first-row"></th>
										<th class="wid-6pt4-p sticky-row first-row">
											Casual BF
										</th>
										<th class="wid-6pt4-p sticky-row first-row">
											Annual BF
										</th>
										<th class="wid-6pt4-p sticky-row first-row">
											Casual Added
										</th>
										<th class="wid-6pt4-p sticky-row first-row">
											Annual Added
										</th>
										<th class="wid-6pt4-p sticky-row first-row">
											Casual Taken
										</th>
										<th class="wid-6pt4-p sticky-row first-row">
											Annual Taken
										</th>
										<th class="wid-6pt4-p sticky-row first-row">
											Off Days
										</th>
										<th class="wid-6pt4-p sticky-row first-row">
											LWP
										</th>
										<th class="wid-6pt4-p sticky-row first-row">
											NEL
										</th>
										<th class="wid-6pt4-p sticky-row first-row">
											Casual CF
										</th>
										<th class="wid-6pt4-p sticky-row first-row">
											Annual CF
										</th>
										<th class="wid-6pt4-p sticky-row first-row">
											Lapsed
										</th>
										<th class="wid-6pt4-p sticky-row first-row">
											Cashed
										</th>
									</tr>
								</thead>
								<tbody>
									<tr class="small font-weight-bold text-right" *ngFor="let summary of summaryList">
										<td class="text-left">{{ FindEmployeeName(summary.fkEmpId) }}</td>
										<td>
											<button (click)="OpenEncashModule(summary)"
												class="btn btn-sm btn-outline-success border-0" data-toggle="modal"
												data-target="#exampleModalCenter" placement="top"
												ngbTooltip="Encash leaves for {{FindEmployeeName(summary.fkEmpId)}}">
												<i class="fas fa-money-bill-alt"></i>
											</button>
										</td>
										<td>{{ summary.OldCasualBalance | number: '1.2-2' }}</td>
										<td>{{ summary.OldAnnualBalance | number: '1.2-2' }}</td>
										<td contenteditable="true"
											(blur)="UpdateCasualAdded($event, summary.pkSummaryId)">
											{{ summary.CasualBalanceAdded | number: '1.2-2' }}
										</td>
										<td contenteditable="true"
											(blur)="UpdateAnnualAdded($event, summary.pkSummaryId)">
											{{ summary.AnnualBalanceAdded | number: '1.2-2' }}
										</td>
										<td>{{ summary.CasualLeaves | number: '1.2-2' }}</td>
										<td>{{ summary.AnnualLeaves | number: '1.2-2' }}</td>
										<td>{{ summary.OffDaysWorked | number: '1.2-2' }}</td>
										<td>{{ summary.LWP | number: '1.2-2'}}</td>
										<td contenteditable="true" (blur)="UpdateNEL($event, summary.pkSummaryId)">
											{{ summary.NotEnoughLeaves | number: '1.2-2' }}
										</td>
										<td>{{ summary.NewCasualBalance | number: '1.2-2' }}</td>
										<td>{{ summary.NewAnnualBalance | number: '1.2-2' }}</td>
										<td>
											{{ summary.LeavesLapsed | number: '1.2-2' }}
										</td>
										<td>
											{{ summary.LeavesCashed | number: '1.2-2' }}
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>